import { BlocksMediaType, MediaBlock } from '../mediaBlock/MediaBlock';
import { DefaultBlockProps } from '../switchBlock/SwitchBlock';
import { BlocksTextType, TextBlock } from '../textBlock/TextBlock';
import style from './MixedBlock.module.scss';

export type BlocksMixedType = DefaultBlockProps & {
  block_type: 'mixed';
};

export const MixedBlock = (props: BlocksMixedType): JSX.Element | null => {
  // Child media always 50% width
  // Child text always 50% width
  // Text left/right determined by text_position
  // rester the textblock alignment though

  const mediaProps: BlocksMediaType = { ...props, block_type: 'media', layout: 'responsive' };
  const textProps: BlocksTextType = { ...props, text_position: undefined, block_type: 'text' };

  const containerState = props.text_position === 'right' ? style.containerIstextRight : null;
  return (
    <div className={`${style.container} ${containerState} block-mixed`}>
      <div className={`${style.media} block-mixed__media`}>
        <MediaBlock {...mediaProps} />
      </div>
      <div className={`${style.text} block-mixed__text`}>
        <TextBlock {...textProps} />
      </div>
    </div>
  );

  return null;
};
